'use client';
import React from 'react';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

const projects = [
  {
    title: 'Ferraz & Maul',
    subTitle: 'Branding',
    images: [
      '/assets/imgs/works/project1_1.png',
      '/assets/imgs/works/project1_2.png',
      '/assets/imgs/works/project1_3.png',
      '/assets/imgs/works/project1_4.png',
    ],
  },
  {
    title: 'FlowGym',
    subTitle: 'Branding',
    images: [
      '/assets/imgs/works/project2_1.png',
      '/assets/imgs/works/project2_2.png',
      '/assets/imgs/works/project2_3.png',
      '/assets/imgs/works/project2_4.png',
    ],
  },
  {
    title: 'New Way',
    subTitle: 'Campanha',
    images: [
      '/assets/imgs/works/project3_1.png',
      '/assets/imgs/works/project3_2.png',
      '/assets/imgs/works/project3_3.png',
      '/assets/imgs/works/project3_4.png',
    ],
  },
];

function Portfolio() {
  const marquess = ['Nossos Trabalhos'];
  const AllMarquess = Array(10).fill(marquess).flat();

  const swiperOptions = {
    modules: [Pagination, Navigation],
    slidesPerView: 1,
    spaceBetween: 40,
    loop: true,
    speed: 800,
    pagination: {
      el: '.work-bento .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.bento-nav-next',
      prevEl: '.bento-nav-prev',
    },
  };

  return (
    <section
      id="portfolio"
      className="work-fade section-padding sub-bg bord-top-grd bord-bottom-grd"
    >
      <div className="container position-re">
        <div className="sec-head mb-60">
          <div className="d-flex align-items-center wow fadeInUp">
            <div>
              <span className="sub-title main-color mb-5">Portfólio</span>
              <h3 className="fw-600 text-u" style={{ fontSize: 'clamp(1.8rem, 4vw, 3.2rem)' }}>
                Trabalhos <span className="fw-200">selecionados.</span>
              </h3>
            </div>
            <div className="ml-auto d-flex align-items-center" style={{ gap: '12px' }}>
              <button
                className="bento-nav bento-nav-prev"
                aria-label="Anterior"
                type="button"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="19" y1="12" x2="5" y2="12"></line>
                  <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
              </button>
              <button
                className="bento-nav bento-nav-next"
                aria-label="Próximo"
                type="button"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div className="work-bento">
          <Swiper {...swiperOptions} className="swiper-container">
            {projects.map((project, i) => (
              <SwiperSlide key={i}>
                <div className="d-flex justify-content-between align-items-end mb-30 flex-wrap">
                  <div>
                    <h4 className="mb-5">{project.title}</h4>
                    <span className="sub-title main-color">
                      {project.subTitle}
                    </span>
                  </div>
                  <span style={{ opacity: 0.5, fontSize: '0.9rem' }}>
                    {String(i + 1).padStart(2, '0')} /{' '}
                    {String(projects.length).padStart(2, '0')}
                  </span>
                </div>

                <div
                  className="bento-grid"
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: '16px',
                  }}
                >
                  {project.images.map((src, imgIdx) => (
                    <div
                      key={imgIdx}
                      style={{
                        position: 'relative',
                        aspectRatio: '16 / 9',
                        borderRadius: '16px',
                        overflow: 'hidden',
                        background: '#0f0f0f',
                      }}
                    >
                      <img
                        src={src}
                        alt=""
                        style={{
                          position: 'absolute',
                          inset: 0,
                          width: '100%',
                          height: '100%',
                          objectFit: 'contain',
                        }}
                      />
                    </div>
                  ))}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div
            className="swiper-pagination"
            style={{ position: 'static', marginTop: '40px', textAlign: 'center' }}
          ></div>
        </div>
      </div>

      <div className="marq-head">
        <div className="main-marq xlrg text-u o-hidden">
          <div className="slide-har st1">
            <div className="box">
              {AllMarquess.map((item, i) => (
                <div key={i} className="item">
                  <h4>{item}</h4>
                </div>
              ))}
            </div>
            <div className="box">
              {AllMarquess.map((item, i) => (
                <div key={i} className="item">
                  <h4>{item}</h4>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .bento-nav {
          width: 52px;
          height: 52px;
          border-radius: 50%;
          border: 1px solid rgba(255, 255, 255, 0.18);
          background: transparent;
          color: #fff;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
          padding: 0;
        }
        .bento-nav:hover {
          background: #F5C518;
          border-color: #F5C518;
          color: #000;
        }
        .bento-nav.swiper-button-disabled {
          opacity: 0.3;
          cursor: not-allowed;
        }
        @media (max-width: 768px) {
          .bento-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
}

export default Portfolio;
